module.exports = __webpack_public_path__ + "img/company2-completed@2x.99f5b5ea.png";